import React from 'react';
import PageEnvelope from '../elements/PageEnvelope';
import { Server } from 'src/server/server';
import { NavLink } from 'react-router-dom';
import { BsFillPeopleFill, BsPlusLg, BsSearch } from 'react-icons/bs';
import './SitePage.css'
import './DashboardPage.css'

interface DashboardPageState {
  loading: boolean;
}

class DashboardPage extends React.Component<{}, DashboardPageState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount(): void {
    this.loadCommunities();
  }

  async loadCommunities() {
    let communities = Server.user.getCommunities();

    if(communities.length > 0) {
      let ids = [];
      for(let i = 0; i < communities.length; i++) 
        ids.push(communities[i].id);
      await Server.public.loadCommunities(ids);
    }

    this.setState({loading: false})
  }

  onVisit(community:any) {
    let email = window.localStorage.getItem('RefreshEmail');
    let token = window.localStorage.getItem('RefreshToken');
    let auth = (email && token) ? `/login?${email}&${token}` : '';

    let url = window.location.host;
    if(url.indexOf('www') == 0)
      url = url.replace('www', community.slug)
    else
      url = community.slug + '.' + url;

    url = window.location.protocol + '//' + url; // + auth;

    window.open(url, '_blank');
  }

  renderCommunities(host:boolean) {
    let communities = Server.user.getCommunities();

    let divs = [];
    for(let i = 0; i < communities.length; i++) {
      let community = Server.public.getCommunity(communities[i].id);

      if(community.host == Server.user.getId() && !host)
        continue;

      if(community.host != Server.user.getId() && host)
        continue;

      let icon = community.icon;
      if(icon.indexOf('https://s3.us-west-2.amazonaws.com/oneclick.media') !== -1) 
        icon = icon.replace('https://s3.us-west-2.amazonaws.com/oneclick.media', 'https://d27jhqexqrz634.cloudfront.net');

      divs.push(
        <div key={i} className="dashboard-page-community-row" onClick={()=>this.onVisit(community)}>
          <img style={{width: '40px'}} src={icon}/>
          <div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
              <div>{community.name}</div>
              <div>{community.members}&nbsp;&nbsp;<BsFillPeopleFill style={{fontSize: '1.1em', marginBottom: '-3px'}} /></div>
            </div>
            <div style={{fontSize: '0.9em', marginTop: '2px'}}>{community.description}</div>
          </div>
          {/* <div style={{position: 'absolute', right: '0px', top: '-2px'}}>
            {community.members}&nbsp;&nbsp;<BsFillPeopleFill style={{fontSize: '1.1em', marginBottom: '-3px'}} />
          </div> */}
        </div>
      )
    }

    return (
      <div className="site-page-panel" style={{padding: '10px', rowGap: '15px'}}>
        {divs.length == 0 ? 'None yet.' : divs}
      </div>
    )
  }

  render() {
    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div className="site-page-column">

            <div>Communities you have created:</div>
            {this.state.loading ? <div className="site-page-panel">Loading...</div> : this.renderCommunities(true)}

            <div style={{textAlign: 'right'}}>
              <NavLink to="/create">
                <button>
                  <div style={{display: 'flex', alignItems: 'center', textDecoration: 'none'}}><BsPlusLg/>&nbsp;Create</div>
                </button>
              </NavLink>
            </div>

            <div style={{marginTop: '10px'}}>Communities you have joined:</div>
            {this.state.loading ? <div className="site-page-panel">Loading...</div> : this.renderCommunities(false)}

            <div style={{textAlign: 'right'}}>
              <NavLink to="/join">
                <button>
                  <div style={{display: 'flex', alignItems: 'center', textDecoration: 'none'}}><BsSearch/>&nbsp;&nbsp;Search</div>
                </button>
              </NavLink>
            </div>
          </div>
        </PageEnvelope>
      </div>
    )
  }
}

export default DashboardPage;